export class TableSettings {
	resizableColumns: boolean = true;
	draggableColumns: boolean = true;
	search: boolean = true;
	filters: boolean = true;
	columnsSettings: boolean = true;
	pagination: boolean = true;
	defaultPageSize: number = 25;
	pageSizeOptions: Array<number> = [10, 25, 50, 100];
	stickyFirstColumn: boolean = true;
	firstColumnWidth: number = 300;
	excelDownload: boolean = true;
	grouping: boolean = false;

	constructor(params?: ITableSettingsParams) {
		if (!params) return;

		this.resizableColumns = params.resizableColumns ?? this.resizableColumns;
		this.draggableColumns = params.draggableColumns ?? this.draggableColumns;
		this.search = params.search ?? this.search;
		this.filters = params.filters ?? this.filters;
		this.columnsSettings = params.columnsSettings ?? this.columnsSettings;
		this.pagination = params.pagination ?? this.pagination;
		this.defaultPageSize = params.defaultPageSize ?? this.defaultPageSize;
		this.stickyFirstColumn = params.stickyFirstColumn ?? this.stickyFirstColumn;
		this.firstColumnWidth = params.firstColumnWidth ?? this.firstColumnWidth;
		this.pageSizeOptions = params.pageSizeOptions ?? this.pageSizeOptions;
		this.excelDownload = params.excelDownload ?? this.excelDownload;
		this.grouping = params.grouping ?? this.grouping;
	}

	get hasSomeOptionForBar(): boolean {
		return this.search || this.filters || this.columnsSettings || this.excelDownload || this.grouping;
	}
}

interface ITableSettingsParams {
	resizableColumns?: boolean;
	draggableColumns?: boolean;
	search?: boolean;
	filters?: boolean;
	columnsSettings?: boolean;
	pagination?: boolean;
	defaultPageSize?: number;
	pageSizeOptions?: Array<number>;
	stickyFirstColumn?: boolean;
	firstColumnWidth?: number;
	excelDownload?: boolean;
	grouping?: boolean;
}